import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=34bc4ec4&"
import script from "./LoginLayout.vue?vue&type=script&lang=js&"
export * from "./LoginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Alert: require('/home/runner/work/lareverde-shop/lareverde-shop/components/core/Alert.vue').default})
